import { render } from "./PriceSkeleton.vue?vue&type=template&id=284a470c&scoped=true"
import script from "./PriceSkeleton.vue?vue&type=script&lang=js"
export * from "./PriceSkeleton.vue?vue&type=script&lang=js"

import "./PriceSkeleton.vue?vue&type=style&index=0&id=284a470c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284a470c"]])

export default __exports__